module.exports = __webpack_public_path__ + "static/media/ind.5b64faee.jpg";